<template>
  <div
    ref="myReleaseBlock"
    class="dashboard-block release-list">
    <div class="dashboard-block__heading draft-release__title">
      <h3 class="draft-release__title-flex">
        <div class="c-btn--edit2"></div>
        作成中のリリース
      </h3>
      <router-link
        :to="{ name: 'release-index' }">
        <div class="draft-release__index-link">
          <span class="draft-release__index-text">一覧へ</span>
          <span
            class="
            c-btn__icon-arrow
            c-btn__icon-arrow--def
            release-shortcut-nav__arrow
          ">
          </span>
        </div>
      </router-link>
    </div>
    <div class="dashboard-block__inner">
      <div class="c-table-caption">横にスクロールしてご覧ください</div>
      <div class="my-release-list">
        <release-table
          title="作成中のリリース"
          :release-status="releaseStatuses"
          :hide-control2="true"
          :hide-control3="true"
          @on-pagination-clicked="scrollTo('myReleaseBlock')">
          <template v-slot:control1="slotProps">
            <div
              class="c-btn--note"
              @click.prevent="onEditReleaseClicked(slotProps.release)">
            </div>
          </template>
          <template #control2>
            <div class="c-btn--delivery"></div>
          </template>
          <template v-slot:control3="slotProps">
            <div
              class="c-btn-wrap draft-release__c-btn-wrap"
              @click.prevent="onEditReleaseClicked(slotProps.release)">
              <div class="c-btn draft-release__c-btn">
                <div class="draft-release__btn-text">続きを入力する</div>
                <span class="c-btn__icon-arrow draft-release__c-btn-arrow"></span>
              </div>
            </div>
          </template>
          <template #empty>
            デリバリ済みのリリースはありません。
          </template>
        </release-table>
      </div>
    </div>
  </div>
</template>

<script>
import ReleaseTable from '../../Release/ReleaseTable'
import {
  CMAP_RELEASE_STATUS_DRAFT,
} from '../../../../consts/status'

export default {
  name: 'DashboardDraftRelease',
  components: { ReleaseTable },
  computed: {
    releaseStatuses() {
      return [CMAP_RELEASE_STATUS_DRAFT]
    },
  },
  methods: {
    async onEditReleaseClicked(release) {
      const { data } = await window.axios.get(`/api/client/products/${release.id}/release`)
      window.sessionStorage.setItem('album', JSON.stringify(data))
      this.$router.push({ name: `release-${data.type === 'single' ? 'single' : 'album'}-step2` })
    },
    scrollTo(elementName) {
      const target = this.$refs[elementName]

      if (!target) {
        return
      }

      const element = target.$el || target

      if (typeof element.scrollIntoView === 'function') {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })
      }
    },
  },
}
</script>

<style scoped>

</style>
